import React, { PureComponent, createRef } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Checkbox, FormControlLabel, Button } from '@material-ui/core'

// actions

import {
  login,
  switchApp,
  renewSession,
  showSessionTimeoutModal,
  reviewCompanyAgreement,
} from '../actions/auth'
import { isLoggedIn, logOut } from '../utils/api'
import { openErrorMessage } from '../actions/message'
// local files

import ModifiedTextInput from '../components/common/ModifiedTextInput'
import ContainerWithTitle from './HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'
import qs from 'query-string'
import { appTargets } from '../utils/constants'
import validateInput from '../utils/validations/Login'
import moment from 'moment'

import DocusignModal from '../components/Modal/DocusignModal'
import { saveCompanyAgreement } from '../actions/company'

class NoAccess extends PureComponent {
  state = {
    email: '',
    loading: false,
    showDocusignModal: false,
  }

  timeout = null

  componentDidMount() {}

  onViewTerms = () => {
    this.setState({
      showDocusignModal: true,
    })
  }

  onDocusignAccept = (agreement) => {
    this.setState({ showDocusignModal: false })
    if (agreement.status == 'agreed') {
      this.props
        .dispatch(saveCompanyAgreement(this.props.docuRes.userId, agreement.clickwrapId))
        .then((res) => {
          this.props.history.push('/')
          window.location.reload()
        })
    }
  }

  onDocusignDecline = (agreement) => {
    this.setState({ showDocusignModal: false })
  }

  render() {
    const { showDocusignModal } = this.state

    const { docuRes = {} } = this.props

    return (
      <div>
        <div>
          <h2 className="" style={{ textAlign: 'center' }}>
            {(docuRes && docuRes.notificationTitle) || ''}
          </h2>
        </div>
        <div>
          <h3 className="slim-heading" style={{ textAlign: 'center' }}>
            {(docuRes && docuRes.notificationBody) || ''}
          </h3>
        </div>

        <div className="margin-top-medium" style={{ textAlign: 'center' }}>
          <Button size="small" onClick={this.onViewTerms} className="" id="view-terms-button">
            {(docuRes && docuRes.notificationButton) || ''}
          </Button>
        </div>

        {showDocusignModal && (
          <DocusignModal
            onAccept={this.onDocusignAccept}
            onDecline={this.onDocusignDecline}
            docuRes={docuRes}
          />
        )}
      </div>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(NoAccess)



// WEBPACK FOOTER //
// ./src/containers/NoAccess.js